import ShareableLinkNotFound from './ShareableLinkNotFound.component';

export default ShareableLinkNotFound;
